export default __webpack_public_path__ + "images/a46e9f20ddaf1d7fd7a90cdb0f488426.svg";